import { all, fork } from 'redux-saga/effects';

import AppSagas from '~/sagas/app-sagas';
import AssetMapAndDetailsSaga from '~/sagas/asset-map-and-details-saga';
import AssetTagsSaga from '~/ducks/asset-tags/asset-tags-sagas';
import AssetTagRelationshipsSaga from '~/ducks/asset-tag-relationships/asset-tag-relationships-sagas';
import AccessGroupsAssetsSaga from '~/ducks/access-groups-assets/access-groups-assets-sagas';
import AuthenticationSagas from '~/sagas/authentication-sagas';
import CompanySettingsSagas from '~/domain/company/store/company-settings-sagas';
import DeleteInviteSagas from '~/sagas/delete-invite-sagas';
import DeleteRequestSagas from '~/sagas/delete-request-sagas';
import DeleteUserSagas from '~/sagas/delete-user-sagas';
import EditUserSagas from '~/sagas/edit-user-sagas';
import GatewaysSagas from '~/sagas/gateways-sagas';
import LegalDocumentsSagas from '~/sagas/legal-documents-sagas';
import MachineFilterV2Sagas from '~/sagas/machine-filter-v2-sagas';
import MachineSagas from '~/sagas/machine-sagas';
import InviteUserSagas from '~/sagas/invite-user-sagas';
import RoboticMowerCommandSagas from '~/ducks/robotic-mower-command/robotic-mower-command-sagas';
import RoboticMowerSocketUpdateSagas from '~/sagas/websocket-updates-sagas';
import RouterSagas from '~/ducks/router/router-sagas';
import UserManagementSubmenuSagas from '~/sagas/user-management-submenu-sagas';
import UserRolesSagas from '~/sagas/user-roles-sagas';
import YoutubePlaylistSagas from '~/sagas/youtube-playlist-sagas';

const allSagas = [
  ...AppSagas,
  ...AssetMapAndDetailsSaga,
  ...AssetTagsSaga,
  ...AssetTagRelationshipsSaga,
  ...AccessGroupsAssetsSaga,
  ...AuthenticationSagas,
  ...CompanySettingsSagas,
  ...DeleteInviteSagas,
  ...DeleteRequestSagas,
  ...DeleteUserSagas,
  ...EditUserSagas,
  ...GatewaysSagas,
  ...LegalDocumentsSagas,
  ...MachineFilterV2Sagas,
  ...MachineSagas,
  ...InviteUserSagas,
  ...RouterSagas,
  ...RoboticMowerCommandSagas,
  ...RoboticMowerSocketUpdateSagas,
  ...UserManagementSubmenuSagas,
  ...UserRolesSagas,
  ...YoutubePlaylistSagas,
];

export default function* rootSaga() {
  yield all(allSagas.map(fork));
}
